var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 32 32",
        fill: _vm.color,
      },
    },
    [
      _c("title", [_vm._v("start-polit")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.152 13.27c0-1.414-1.169-2.584-2.584-2.584s-2.584 1.169-2.584 2.584c0 1.414 1.169 2.584 2.584 2.584s2.584-1.169 2.584-2.584zM17.346 13.27c0 2.626-2.151 4.777-4.777 4.777s-4.777-2.151-4.777-4.777c0-2.626 2.151-4.777 4.777-4.777s4.777 2.151 4.777 4.777zM12.569 25.408c3.477 0 5.913-0.464 7.394-1.040 0.561-0.218 0.928-0.43 1.151-0.595-0.292-0.279-0.827-0.633-1.657-0.979-1.654-0.691-4.086-1.187-6.889-1.187s-5.235 0.497-6.889 1.187c-0.83 0.347-1.364 0.701-1.657 0.979 0.224 0.165 0.59 0.377 1.151 0.595 1.482 0.576 3.918 1.040 7.394 1.040zM12.569 27.602c-7.279 0-10.919-1.927-10.919-3.735 0-2.321 4.853-4.454 10.919-4.454s10.919 2.133 10.919 4.454c0 1.808-3.64 3.735-10.919 3.735zM3.768 23.541c-0 0 0.001 0.001 0.003 0.004l-0.003-0.004zM3.823 24.007c-0.003 0.006-0.005 0.009-0.004 0.010s0.002-0.003 0.004-0.010zM21.318 24.017c0 0-0.001-0.003-0.004-0.009 0.002 0.006 0.004 0.009 0.004 0.009zM21.367 23.544c0.002-0.003 0.003-0.004 0.003-0.004l-0.003 0.004z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.167 4.398c-0.603 0-1.092 0.489-1.092 1.092v18.972c0 0.603 0.489 1.092 1.092 1.092s1.092-0.489 1.092-1.092v-8.681l7.76-4.656c0.442-0.265 0.442-0.905 0-1.17l-7.779-4.667c-0.095-0.506-0.539-0.89-1.073-0.89z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }